<div class="modal-full">
    <div class="flex-fill d-flex flex-column overflow-y-auto modal-user-form">
        <div class="mb-1">
            <b>Edit User</b>
        </div>
        <div class="page-header title-margin">{{userName}}</div>
        <br>
        <mat-tab-group>
            <!-- User profile tab -->
            <mat-tab label="User Profile">
                <div class="mt-4">
                    <app-edit-user-profile [selectedUser]="selectedUser"
                    (formValidityChanged)="onFormValidityChanged($event)"
                    (formSaveStateChanged)="onFormSaveStateChanged($event)"/>
                </div>
            </mat-tab>

            <!-- Assignment tab -->
            <mat-tab label="Assignments">
                <ng-template matTabContent>
                    <div class="flex flex-row">
                        <h2 style="align-content:center">Assignments</h2>
                        <mat-form-field class="filter-clients-and-accounts" id="filterClientsAndAccountsFormField" floatLabel="never"
                            appearance="fill">
                            <input matInput placeholder="Search" (keyup)="filterClientsAndAccountsByText()"
                                [(ngModel)]="filterText">
                            <mat-icon aria-hidden="false" aria-label="search icon" matSuffix>
                                search
                            </mat-icon>
                        </mat-form-field>
                    </div>
                    <mat-card style="width: 100%;border-radius:16px;box-shadow: none;">
                        <mat-card-content>
                            <div class="flex flex-row assignments-header-table" >
                                <button mat-icon-button class="btn btn-link btn-sm custom" (click)="toggleExpandAll()">
                                    <mat-icon>{{ expandAll ? 'unfold_less' : 'unfold_more' }}</mat-icon>
                                </button>
                                <span class="access-header">Clients</span>
                            </div>
                            <div class="clients-accounts-data">
                                <div *ngFor="let entry of clientAccountsDictionary | keyvalue">
                                    <app-edit-users-client-accounts [userId]="selectedUser.id" [userRoleId]="selectedUser.userRoleId"
                                        [loggedInUserAccounts]="entry.value" [editedUserClientAccounts]="filterClients(entry)"
                                        [expandClientAccounts]="expandAll" [isReadOnly]="isReadOnly" (updateSaved)="reloadUpdatedUser()" (formSaveStateChanged)="onFormSaveStateChanged($event)" />
                                    <div class="line"></div>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </ng-template>
            </mat-tab>
            <mat-tab label="User Activity">
                <ng-template matTabContent>
                    <div *ngIf="selectedUser">
                        <app-user-activity [selectedUser]="selectedUser" ></app-user-activity>
                    </div>
                </ng-template>
            </mat-tab>

            <!-- Unavailable Schedule tab -->
            <mat-tab label="Availability" *ngIf="unavailabilityScheduleEnabled">
                <ng-template matTabContent>
                    <app-unavailability-schedule [selectedUser]="selectedUser"></app-unavailability-schedule>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>

    <!-- close -->
    <div class="flex-center-bottom">
        <div class="close-box">
          <span>{{userFormState}}</span>
            <button style="justify-content: flex-end;" type="button" mat-button color="primary" class="material-default" [disabled]="!isUserFormValid" (click)="close()">
                Close</button>
        </div>
    </div>
</div>